import { ol_proj } from "@omnia/exports/openlayers"
import { omniaResolve } from "../promises"
import { IOmniaHttpService } from "../types"
import { MapLocationsApiResult } from "./types"

export function queryLocationsApi(http: IOmniaHttpService, query: string, suffix: string, apikey: string): PromiseLike<{ name: string, bbox: number[] }[]> {

    query = query || ""

    if (query.length < 3) {
        return omniaResolve([])
    }

    let url = "https://dev.virtualearth.net/REST/v1/Locations"

    query = prepareQuery(query, suffix)

    url += "?q=" + encodeURIComponent(query);
    url += "&maxResults=10";
    url += "&key=" + apikey

    return http.getExternal(url).then(r => {
        return r.resourceSets[0].resources || []

    })

}

function prepareQuery(query: string, suffix: string) {

    if (!suffix) {
        return query
    }

    if (query.charAt(0) == "+") {
        query = query.substring(1)
    }
    else {
        query = query + ", " + suffix
    }

    return query

}

export function transformLocationApiResult(value: MapLocationsApiResult) {

    const b = value?.bbox4326

    if (b) {

        const minmax = (a: number, b: number) => a > b ? [b, a] as const : [a, b] as const

        const [ymin, ymax] = minmax(b.ymin, b.ymax)
        const [xmin, xmax] = minmax(b.xmin, b.xmax)

        const extent = [
            xmin,
            ymin,
            xmax,
            ymax,
        ]

        return ol_proj.transformExtent(extent, "EPSG:4326", "EPSG:3857")

    }


}
